import React, { Component, ReactComponentElement } from "react";
import styles from "./detailBloodStationContainer.module.scss";

export default class DetailBloodStationContainer extends Component<any, any> {
  props: {
    children: ReactComponentElement<any>;
    rowStart?: number;
    rowEnd?: number;
    columnStart?: number;
    columnEnd?: number;
    isGrid?: boolean;
    mb?: string;
    mt?: string;
    stopProp?: boolean;
  };

  render() {
    const { props } = this;
    const {
      children,
      columnEnd,
      columnStart,
      isGrid,
      rowEnd,
      rowStart,
      mb = "24px",
      stopProp = false,
      mt = "0px",
    } = props;
    return (
      <div
        onClick={stopProp ? (e) => e.stopPropagation() : null}
        className={styles.DetailBloodStationContainer}
        style={
          isGrid
            ? {
                gridRowStart: rowStart,
                gridRowEnd: rowEnd,
                gridColumnStart: columnStart,
                gridColumnEnd: columnEnd,
                marginBottom: mb,
              }
            : { marginBottom: mb, marginTop: mt }
        }
      >
        <div className={"container"}>{children}</div>
      </div>
    );
  }
}
